import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MassCommunicationComponent } from './mass-communication.component'; // Explicitly import the component
import { MassCommunicationRoutingModule } from './mass-communication-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatChipsModule,
        MatAutocompleteModule,
        SharedComponentsModule, // Import shared components module if needed
        MassCommunicationRoutingModule // Add the routing module here
        ,
        MassCommunicationComponent
    ]
})
export class MassCommunicationModule {}
